module.exports = __webpack_public_path__ + "img/Bodice-Front-B3-Da-Ea.d639dc92.png";